export default __webpack_public_path__ + "static/media/step3Img.59f1a3c6.svg";